<template>
  <a :href="item.url" class="scout-popup-list-item">
    <img :src="companyLogoUrl" class="company-logo" />
    <div class="company-name" v-text="item.company.name"></div>
    <ArrowIcon class="forward-arrow" />
  </a>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { ScoutPopupItem } from 'oc2api/popup';
import noImageIcon from 'images/noimage.png';
import ArrowIcon from 'images/arrow_forward_ios.svg';

export default defineComponent({
  name: 'ScoutPopupListItem',
  components: {
    ArrowIcon,
  },
  props: {
    item: {
      type: Object as PropType<ScoutPopupItem>,
      required: true,
    },
  },
  setup(props) {
    const companyLogoUrl = computed(() => props.item.company.square_logo ?? noImageIcon);
    return {
      companyLogoUrl,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.scout-popup-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid $oc-border;
  border-radius: 2px;
  background: white;

  font-size: 16px;
  line-height: 24px;

  & + .scout-popup-list-item {
    margin-top: 8px;
  }

  .company-logo {
    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid $oc-border;
  }

  .company-name {
    flex: auto;
    overflow-x: hidden;
    margin: 0 8px;
    font-size: 12px;
    line-height: 19px;
    font-weight: 700;
    color: $oc-black;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .forward-arrow {
    flex: none;
    margin: 0 8px;
    width: 10px;
  }
}
</style>
